import React, { useState, useEffect } from 'react';
import { navStyle, navButton, activeButton, button } from "./navigation.module.css"
import { PersonalPreference, catagories, typesOfQuestions } from './questions'
import { shuffle, areEqual, oxfordComma } from '../common'
import { PreferenceResponse, NormalResponse, PreferenceFinal } from './response'
import {
	nav,
	teaquiz,
	scoreSection,
	notesSection,
	questionArea,
	questionSection,
	questionCount,
	questionTitle,
	questionText,
	answerSection,
	tags,
	points
} from "./teaquiz.module.css"

import {MultipleSelect, SingleSelect} from './forms'

export function TeaQuiz({ className }) {
	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [showScore, setShowScore] = useState(false);
	const [score, setScore] = useState(0);
	const [correctAnswer, setCorrectAnswer] = useState();
	const [currentAnswer, setCurrentAnswer] = useState();
	const [displayResponse, setDisplayResponse] = useState(false);
	const [response, setResponse] = useState();
	const [totalScore, setTotalScore] = useState(0);
	const [questionSet, setQuestionSet] = useState(PersonalPreference);
	const [isPreference, setIsPreference] = useState(true);
	const [correctness, setCorrectness] = useState(true);
	const [answerArray, setAnswerArray] = useState([]);
	
	let questions = questionSet.questions
	let defaultImage = questionSet.defaultImage

	useEffect(() => checkQuizMode())

	const chooseCatagory = (name) => {
		let value = []
		typesOfQuestions.forEach((q) => value.push(q.catagory))
		for (let i=0; i<value.length; i++)
			if (name === value[i]) {
				value = i
				setQuestionSet(typesOfQuestions[value])
				defaultImage = questionSet.defaultImage
			}
		checkQuizMode()
	    setCurrentQuestion(0)
	    setScore(0)
	    setShowScore(false)
		setDisplayResponse(false)
	    return
	}

	const randomCatagory = () => {
	    let i = Math.floor(Math.random() * typesOfQuestions.length)
	    setQuestionSet(typesOfQuestions[i])
	    defaultImage = questionSet.defaultImage
		checkQuizMode()
	    setCurrentQuestion(0)
	    setScore(0)
	    setShowScore(false)
		setDisplayResponse(false)
	    return
	}

	const checkQuizMode = () => {
		if (questionSet.questions[0].questionDifficulty !== 0) {
			return setIsPreference(false)
		} else {
			return setIsPreference(true)
		}
	}

	const changeToNextQuestion = () => {
		let nextQuestion = currentQuestion + 1;
		if (nextQuestion < questions.length) {
			setCurrentQuestion(nextQuestion);
			return
		} else {
			setShowScore(true);
			return
		}
	}

	const continueNow = () => {
		changeToNextQuestion()
		setDisplayResponse(false)
		setResponse("")
		if (checkCorrectness()) {
			setCorrectness(false)
		}
		return
	}

	let answersList = []
	let correctList = []
	const listAnswers = () => {
		if (questions[currentQuestion].questionDifficulty !== 0) {
			questions[currentQuestion].answerOptions.correct.map((x) => (
				correctList.push(x)
			))
			questions[currentQuestion].answerOptions.incorrect.map((x) => (
				answersList.push(x)
			))
			answersList = answersList.concat(correctList)
			
			return shuffle(answersList)	
		} else {
			questions[currentQuestion].answerOptions.correct.map((x) => (
				correctList.push(x)
			))
			return answersList = correctList
		}
	}
	listAnswers()

	const checkCorrectness = (answer) => {
		if (questions[currentQuestion].questionDifficulty !== 0) {
			let arr = []
			arr.push(answer)
			if (areEqual(arr, correctList)) {
				setScore(score + questions[currentQuestion].questionDifficulty);
				setTotalScore(totalScore + questions[currentQuestion].questionDifficulty)
				setCorrectness(true)
				setCorrectAnswer(questions[currentQuestion].answerOptions.correct[0])
				setCurrentAnswer(answer)
				return
			}
			setCorrectness(false)
			setIsPreference(false)
			setCorrectAnswer(questions[currentQuestion].answerOptions.correct[0])
			setCurrentAnswer(answer)
		} else {
			setCorrectness(true)
			setIsPreference(true)
		}
	}

	const handleAnswerOptionClick = ( answer ) => {
		checkCorrectness(answer)
		setResponse(questions[currentQuestion].response)
		setDisplayResponse(true)
		answersList = []
		correctList = []
		return
	}
	const handlePreference = (answer) => {
		checkCorrectness(answer)
		answer = questions[currentQuestion].response[0] + oxfordComma(answer) + " " + questions[currentQuestion].response[1]
		setResponse(answer)
		setDisplayResponse(true)
		setAnswerArray([...answerArray, answer])
		return
	}

	return (
		<div className={teaquiz}>
			<button className="hamburger">☰</button>
			<nav className="hidden-menu">
			    <nav className={[navStyle, className].join(" ")}>
			      {catagories.map((name) => (
			        <button
			          key={name}
			          className={navButton}
			          onClick={() => chooseCatagory(name)}
			        >
			          {name.toUpperCase()}
			        </button>
			      ))}
			      <button
			        key="Random"
			        className={navButton}
			        onClick={() => randomCatagory()}
			      >
			        RANDOM CATAGORY
			      </button>
			    </nav>
			</nav>
			{showScore ? ( !isPreference ? (
				<div className={scoreSection}>
					You scored {score} points out of {totalScore} total possible
				</div>
				) : (
					<PreferenceFinal
						answerArray={answerArray}
					/>
				)
			) : ( displayResponse ? (
				<>
					<div className={notesSection}>
						{!correctness ? (
							<>
								<h2>{currentAnswer} </h2> is <em>Not Correct!</em>
								<h3>The correct answer: <br /> <em>{correctAnswer}</em></h3>
								<br />
								<ul className={tags}> {questions[currentQuestion].tags.map((tag) => <li>{tag.toUpperCase()}</li>)}</ul>
								{response}
							</>
							) : ( isPreference ? (
									<PreferenceResponse 
										correctAnswer={correctAnswer}
										response={response}
										questionSet={questionSet}
										currentQuestion={currentQuestion}
										questions={questions}
									/>
								) : (
									<NormalResponse 
										correctAnswer={correctAnswer}
										response={response}
										questionSet={questionSet}
										currentQuestion={currentQuestion}
										questions={questions}
									/>
								)
							)
						}

						<button onClick={() => continueNow()}>
							Continue
						</button>
					</div> 
					<img src={questions[currentQuestion].image || defaultImage} alt={questions[currentQuestion].questionText} />
				</>
			) : ( isPreference ? (
				<MultipleSelect 
					title={questionSet.catagory.toUpperCase()}
					dificulty={questions[currentQuestion].questionDifficulty}
					question={questions[currentQuestion].questionText}
					questions={questions}
					image={questions[currentQuestion].image || defaultImage}
					currentQuestion={currentQuestion}
					answersList={answersList}
					handlePreference={handlePreference}
				/>
			) : (
				<SingleSelect
					title={questionSet.catagory.toUpperCase()}
					dificulty={questions[currentQuestion].questionDifficulty}
					question={questions[currentQuestion].questionText}
					questions={questions}
					image={questions[currentQuestion].image || defaultImage}
					currentQuestion={currentQuestion}
					answersList={answersList}
					score={score}
					handleAnswerOptionClick={handleAnswerOptionClick}
				/>
			)))}
		</div>
	);
}
